import { createReducer } from '@reduxjs/toolkit'
import { featureFlagsConstants } from '../constants/featureFlags.constants'

const initialState = {
    items: [],
    loading: false,
    error: null,
}

export const featureFlagsReducer = createReducer(initialState, builder => {
    builder
        // GET_REQUEST => set loading
        .addCase(featureFlagsConstants.GET_REQUEST, (state, action) => {
            state.loading = true
            state.error = null
        })
        // GET_SUCCESS => store the array of feature flags
        .addCase(featureFlagsConstants.GET_SUCCESS, (state, action) => {
            state.loading = false
            state.items = action.response
            state.error = null
        })
        // GET_FAILURE => set error
        .addCase(featureFlagsConstants.GET_FAILURE, (state, action) => {
            state.loading = false
            state.error = action.error
        })

        .addDefaultCase((state, action) => { })
})
